export default __webpack_public_path__ + "static/media/2.b51eedd4.txt";